import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {Configuration} from "../../assets/Configuration";
import { CourseTemplateSummaryModel } from '../models/course/course-template-summary.model';
import { CourseTemplateFullModel } from '../models/course/course-template-full.model';
import { CourseContentTypeModel } from '../models/course/course-content-type.model';
import { CourseTemplateCreationAndUpdateBaseModel } from '../models/course/course-template-creation-and-update-base.model';
import { CourseTemplateManageSummaryModel } from '../models/course/course-template-manage-summary.model';
import { CourseTemplateModel } from '../models/course/course-template.model';
import { CoursesMergeModel } from '../models/course/courses-merge.model';
import { CoursePersonByStateModel } from '../models/person-states/course-person-by-state.model';
import { RawFileModel } from '../models/raw-file-model';
import { FileModel } from '../models/file.model';

@Injectable({
  providedIn: 'root',
})
export class CourseTemplateService {
  constructor(private httpClient: HttpClient) {}

  public getAllCourseTemplates(): Observable<CourseTemplateSummaryModel[]> {
    return this.httpClient.get<CourseTemplateSummaryModel[]>(
      Configuration.getApiBaseUrl() + '/coursetemplate/'
    );
  }


  public getAllCourseTemplatesForManagement(): Observable<CourseTemplateManageSummaryModel[]> {
    return this.httpClient.get<CourseTemplateManageSummaryModel[]>(
      Configuration.getApiBaseUrl() + '/coursetemplate/management'
    );
  }

  public getAvailableCourses(): Observable<CourseTemplateModel[]> {
    return this.httpClient.get<CourseTemplateModel[]>(
      Configuration.getApiBaseUrl() + '/coursetemplate/available-courses'
    );
  }

  public getAvailableCoursesByComplianceCategory(): Observable<CourseTemplateModel[]> {
    return this.httpClient.get<CourseTemplateModel[]>(
      Configuration.getApiBaseUrl() + '/coursetemplate/available-courses/by-compliance-category'
    );
  }

  public getCourseTemplate(id: string): Observable<CourseTemplateFullModel> {
    return this.httpClient.get<CourseTemplateFullModel>(
      Configuration.getApiBaseUrl() + '/coursetemplate/' + id
    );
  }

  public getOpenCourseTemplates(personId: string): Observable<CourseTemplateSummaryModel[]> {
    const params = new HttpParams()
      .set('personId', personId);
    
    return this.httpClient.get<CourseTemplateSummaryModel[]>(
      Configuration.getApiBaseUrl() + '/coursetemplate/open',
      { params: params }
    );
  }

  public addCourseTemplate(
    model: CourseTemplateCreationAndUpdateBaseModel
  ): Observable<CourseTemplateFullModel> {
    return this.httpClient.post<CourseTemplateFullModel>(
      Configuration.getApiBaseUrl() + '/coursetemplate/',
      model
    );
  }

  public getCourseContentTypeByFileName(
    fileName: string
  ): Observable<CourseContentTypeModel> {
    
    const params = new HttpParams()
      .set('fileName', fileName);

    return this.httpClient.get<CourseContentTypeModel>(
      Configuration.getApiBaseUrl() + '/coursetemplate/course-content-type',
      { params: params }
    );
  }

  public getScormThumbnailByImsManifestXml(
    imsManifestXml: string
  ): Observable<string | null> {
    return this.httpClient.post(
      Configuration.getApiBaseUrl() + '/coursetemplate/scorm-thumbnail-by-ims-manifest',
      { fileContent: imsManifestXml },
      { responseType: 'text' }
    );
  }

  updateCourseTemplate(
    id: string,
    model: CourseTemplateCreationAndUpdateBaseModel
  ) {
    return this.httpClient.post<CourseTemplateFullModel>(
      Configuration.getApiBaseUrl() + '/coursetemplate/' + id,
      model
    );
  }

  public getCourseTemplatePersons(id: string): Observable<CoursePersonByStateModel> {
    return this.httpClient.get<CoursePersonByStateModel>(
      Configuration.getApiBaseUrl() + '/coursetemplate/' + id + '/persons'
    );
  }

  public getCourseTemplateClone(
    id: string
  ): Observable<CourseTemplateFullModel> {
    return this.httpClient.get<CourseTemplateFullModel>(
      Configuration.getApiBaseUrl() + `/coursetemplate/${id}/clone`
    );
  }

  public archiveCourses(ids: string[]) : Observable<null> {
    return this.httpClient.post<null>(
      Configuration.getApiBaseUrl() + `/coursetemplate/archive`,
      ids
    );
  }

  public mergeCourses(request: CoursesMergeModel) : Observable<null> {
    return this.httpClient.post<null>(
      Configuration.getApiBaseUrl() + `/coursetemplate/merge`,
      request
    );
  }

    public addCourseFile(id: string, file: RawFileModel): Observable<FileModel> {
      return this.httpClient.post<FileModel>(
        Configuration.getApiBaseUrl() + "/coursetemplate/" + id + "/file", 
        file
      );
    }
  
    public deleteCourseFile(id: string, fileId: string): Observable<void> {
      return this.httpClient.delete<void>(
        Configuration.getApiBaseUrl() + "/coursetemplate/" + id + "/file/" + fileId
      );
    }
}
